/* eslint-disable jsx-a11y/label-has-for */
import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';

// import Checkbox from '@material-ui/core/Checkbox';
// import { withStyles } from '@material-ui/core/styles';


const Separator = ({
  activeLanguage, handlerSetComponents, components, id, reusableComponent, reusableComponentSlugname,
}) => {
  const initialState = {
    type: 'Separator',
    borderWidth: 3,
    color: 'black',
    marginTop: true,
    backgroundColor: 'transparent',
  };

  // const PageTypeCheckbox = withStyles({
  //   root: {
  //     color: 'black',
  //     padding: 0,
  //     marginRight: '0.5rem',
  //   },
  //   checked: {},
  // })(props => <Checkbox color="default" {...props} />);

  const [index, setIndex] = useState();
  const [state, setState] = useState(initialState);
  const [isColorTransparent, setColorTransparent] = useState(false);
  const [isBorderThin, setBorderThin] = useState(false);
  const [bgColor, setBgColor] = useState('transparent');

  useEffect(() => {
    if (index >= 0 && components.length) {
      const { component } = components[index];
      const borderWidth = isBorderThin ? 1 : 3;

      const comp = {
        ...component,
        borderWidth,
        color: isColorTransparent ? 'transparent' : 'black',
        backgroundColor: bgColor,
      };
      setState(comp);

      const componentObj = {
        id,
        component: comp,
      };

      handlerSetComponents(componentObj, index);
    }
  }, [isColorTransparent, isBorderThin, bgColor]);

  // const handleMarginTop = () => {
  //   const { component } = components[index];

  //   const comp = {
  //     ...component,
  //     marginTop: !state.marginTop,
  //   };

  //   console.log('comp', comp);

  //   setState(comp);

  //   const componentObj = {
  //     id,
  //     component: comp,
  //   };

  //   handlerSetComponents(componentObj, index);
  // };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    const { component } = components[componentIndex];
    if (reusableComponent) {
      setState(reusableComponent);
      if (!component) handlerSetComponents({ component: { key: reusableComponentSlugname } }, componentIndex);
    } else {
      setIndex(componentIndex);
      // console.log('TCL: components[componentIndex]', components[componentIndex]);

      if (component) {
        setColorTransparent(component.color === 'transparent');
        setBorderThin(component.borderWidth === 1);
        setBgColor(component.backgroundColor);
        setState(component);
      } else {
        const componentObj = {
          id,
          component: state,
        };

        handlerSetComponents(componentObj, componentIndex);
      }
    }
  }, [components]);

  return (
    <>
      <div className="w-full bg-greyFilter rounded-lg">
        <div className="py-3px bg-greyFilter pl-13 pr-2 flex items-center rounded-lg">
          <label className="flex flex-row font-americaMonoRegular text-xs uppercase text-black items-center" htmlFor="borderColor">
            Border Color
            <div className="mt-1 pb-0 pl-1">
              <label className="switch mb-0 pb-0 h-6">
                <input checked={isColorTransparent} onChange={() => setColorTransparent(!isColorTransparent)} type="checkbox" />
                <div className="switch-slider btn-btransp switch-round" />
              </label>
            </div>
          </label>
          <label className=" ml-8 flex flex-row font-americaMonoRegular text-xs uppercase text-black items-center" htmlFor="borderWidth">
            Border Width
            <div className="mt-1 pb-0 pl-1">
              <label className="switch mb-0 pb-0 h-6">
                <input className="switch" checked={isBorderThin} onChange={() => setBorderThin(!isBorderThin)} type="checkbox" />
                <div className="switch-slider btn-border switch-round" />
              </label>
            </div>
          </label>
          <div className="relative ml-1">
            <label className=" ml-8 flex flex-row font-americaMonoRegular text-xs uppercase text-black items-center" htmlFor="backgroundColor">
              Change background color
              <input
                className="appearance-none uppercase block ml-1 bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                type="text"
                onChange={e => setBgColor(e.target.value)}
                value={bgColor}
              />
              <input
                className="absolute bg-transparent flex h-full items-center p-1 right-0 text-gray-700 top-0"
                name="color"
                type="color"
                onChange={e => setBgColor(e.target.value)}
                value={bgColor}
              />
            </label>
          </div>
          <div className="relative ml-1">
            <button onClick={() => setBgColor('transparent')} type="button" className="ml-8 rounded-full py-3 px-4 flex flex-row font-americaMonoRegular text-xs uppercase text-black bg-white items-center">
              Transparent
            </button>
          </div>

          {/* <div className="font-americaMonoRegular text-xs uppercase mt-2 w-full pt-1 flex flex-row items-center" htmlFor="marginTop">
            <PageTypeCheckbox checked={state.marginTop === true} value="checkedA" onClick={handleMarginTop} />
            <span className="font-americaMonoRegular text-xs uppercase text-black" onChange={handleMarginTop} onClick={handleMarginTop}>
              Margin Top
            </span>
          </div> */}
        </div>
      </div>
    </>
  );
};

Separator.propTypes = {
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  reusableComponent: PropTypes.shape(),
};
Separator.defaultProps = {
  reusableComponent: null,
};

export default Separator;
